import { useCallback } from 'react';
import { RENDER_ORDER } from '../config/stepsConfig';

function useCanvasDrawing(theSize) {

  const drawToCanvas = useCallback(async (ctx, selectedOptions, renderOrder = RENDER_ORDER, collectionId) => {
    ctx.clearRect(0, 0, theSize, theSize);
    
    for (const stepName of renderOrder) {
      if (selectedOptions[stepName]) {
        await new Promise((resolve) => {
          const image = new Image();
          image.src = require(`../images/${collectionId}/${stepName}/${selectedOptions[stepName].imageName}.png`);
          image.onload = () => {
            ctx.globalAlpha = 1;
            ctx.drawImage(image, 0, 0, theSize, theSize);
            resolve();
          };
          image.setAttribute('crossorigin', 'anonymous');
        });
      }
    }
  }, [theSize]);

  return { drawToCanvas };
}

export default useCanvasDrawing; 